import { createI18n } from "vue-i18n";
const lang = navigator.language;

const i18n = createI18n({
  legacy: false,
  locale: lang.indexOf("en") >= 0 ? "en-US" : "zh-CN"
});

export default i18n;
